var styles = {"navbarLinks":"navkit__NavbarLinks__navbarLinks","navbarLinksItem":"navkit__NavbarLinks__navbarLinksItem","isLoading":"navkit__NavbarLinks__isLoading","original":"navkit__NavbarLinks__original"};

export { styles as default };
